import React, { useEffect, useState } from "react";
import "./Reports.css";
import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { DataLoader } from "../../utils/DataLoader";
import * as AiIcons from "react-icons/ai";
import * as FiIcons from "react-icons/fi";
import dateFormat from "dateformat";
import { ReportFilter } from "../../components/SearchFilter/ReportFilter";
import { filterBy } from "@progress/kendo-data-query";
import { GetCustomerAllReports } from "../../apis/ReportsAPI";

export default function AdminReports() {
  const ControllerNActionName = {
    ControllerName: "Reports",
    ActionName: "getallorderreport",
    SearchField: "order_id",
  };
  const [orders, setOrders] = useState({
    data: [],
    total: 0,
  });
  //const [searchText, setSearchText] = useState(null);
  const [dataState, setDataState] = useState({
    take: 50,
    skip: 0,
    filter: "0",
  });

  const dataStateChange = (e) => {
    setDataState(e.dataState);
  };
  const dataReceived = (orders) => {
    setOrders(orders);
  };
  const initialSort = [
    {
      field: "order_id",
      dir: "desc",
    },
  ];
  const [count, setCount] = useState(1);
  const [sort, setSort] = React.useState(initialSort);
  const [allReport, setAllReport] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);

  const handleSorting = (e) => {
    localStorage.setItem("sortData", true);
    let sortingArray = e.sort;
    sortingArray.forEach((element, i) => {
      if (element.field === "orderId") {
        e.sort[i].field = "order_id";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "customerName") {
        e.sort[i].field = "order_customer_name";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "requestorName") {
        e.sort[i].field = "requestor_name";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "applicantName") {
        e.sort[i].field = "order_applicant_name";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "completionDate") {
        e.sort[i].field = "order_end_date";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      }
    });
    setCount(count + 1);
    setSort(e.sort);
  };
  const handleSearch = async (searchValue) => {
    localStorage.setItem("searchData", true);
    setDataState({ take: 50, skip: 0, filter: searchValue });
  };
  const handleAdvanceSearch = async (searchData) => {
    //console.log(searchData);
    let completionSearch = false;
    if (
      searchData.completionStartDate !== "" &&
      searchData.completionEndDate !== ""
    )
      completionSearch = true;

    let doSearch = false;

    if (
      completionSearch ||
      (searchData.applicantName != null && searchData.applicantName !== "") ||
      searchData.reportType.report_id !== 0
    )
      doSearch = true;

    if (doSearch) {
      var searchBody = {
        isAdvanceSearch: "yes",
        completion_start_date:
          completionSearch === true
            ? dateFormat(searchData.completionStartDate, "yyyy-mm-dd")
            : "",
        completion_end_date:
          completionSearch === true
            ? dateFormat(searchData.completionEndDate, "yyyy-mm-dd")
            : "",
        applicant_name:
          searchData.applicantName == undefined ? "" : searchData.applicantName,
        report_id:
          searchData.reportType.report_id === 0
            ? ""
            : searchData.reportType.report_id + "",
      };
    }
    //console.log(searchBody);
    localStorage.setItem("searchData", true);
    setDataState({ take: 50, skip: 0, filter: searchBody });
  };

  const getReportList = async () => {
    var result = await GetCustomerAllReports(0);
    setAllReport(result.data.slice());
    setReportTypes(result.data.slice());
  };

  const filterData = (filter) => {
    const data = allReport.slice();
    return filterBy(data, filter);
  };

  const reportFilterChange = (e) => {
    setReportTypes(filterData(e.filter));
  };

  useEffect(() => {
    getReportList();
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="admin-page-row orders">
                  <Col lg={6} md={6} sm={12}>
                    <div className="page-title">
                      <h2>Reports</h2>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <div className="search-filter">
                      <ReportFilter
                        search={handleSearch}
                        advSearch={handleAdvanceSearch}
                        reportTypes={reportTypes}
                        reportFilterChange={reportFilterChange}
                        searchPlaceHolder="Search by applicant name"
                        displayShort={false}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Grid
                    sortable={true}
                    sort={sort}
                    onSortChange={(e) => {
                      handleSorting(e);
                    }}
                    pageable={true}
                    {...dataState}
                    data={orders}
                    onDataStateChange={dataStateChange}
                    style={{ height: "75vh" }}
                  >
                    <GridColumn
                      field="orderId"
                      title="Order No"
                      width="100px"
                    />
                    <GridColumn field="customerName" title="customer Name" />
                    <GridColumn field="requestorName" title="Requestor Name" />
                    <GridColumn field="applicantName" title="Applicant Name" />
                    <GridColumn
                      field="completionDate"
                      title="Completion Date"
                      width="120px"
                    />
                    <GridColumn
                      sortable={false}
                      field="id"
                      title="Action"
                      width="150px"
                      cell={(props) =>
                        props.dataItem.isPrimary &&
                        !props.dataItem.templateName.includes("Pdf Reports") ? (
                          <td className="act">
                            <a
                              href={`/Report?type=view&id=${props.dataItem.id}`}
                              className="orderAction"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <AiIcons.AiOutlineEye />
                            </a>
                            &nbsp;&nbsp;
                            <a
                              href={`/Report?type=view_download&id=${props.dataItem.id}&reportname=${props.dataItem.templateName}`}
                              className="orderAction"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <FiIcons.FiDownload />
                            </a>
                          </td>
                        ) : (
                          <td></td>
                        )
                      }
                    ></GridColumn>
                  </Grid>
                  <DataLoader
                    dataState={dataState}
                    onDataReceived={dataReceived}
                    dataItem={ControllerNActionName}
                    dataSort={sort}
                  />
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
